import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import gbsLogo from "./assets/gbs_logo_transparent.png";

export default function Login({ onLogin, onRegister,onBack }) {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [showForgot, setShowForgot] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetSending, setResetSending] = useState(false);
  const [resetMsg, setResetMsg] = useState("");
  const [resetError, setResetError] = useState("");

  useEffect(() => {
    try {
      const saved = localStorage.getItem("savedLoginId");
      if (saved) { setLoginId(saved); setRememberMe(true); }
    } catch {
      // localStorage blocked on this browser -- just skip the saved login id.
    }
  }, []);

  const resolveEmail = async (input) => {
    if (input.includes("@")) return input;
    try {
      const snap = await getDoc(doc(db, "usernames", input.toLowerCase()));
      if (snap.exists()) return snap.data().email;
      return null;
    } catch {
      return null;
    }
  };

  const handleLogin = async () => {
    if (!loginId.trim() || !password.trim()) {
      setError("Email/Username aur password bharein!"); return;
    }
    setLoading(true); setError("");
    try {
      const email = await resolveEmail(loginId.trim());
      if (!email) { setError("Username nahi mila!"); setLoading(false); return; }
      await signInWithEmailAndPassword(auth, email, password);
      try {
        if (rememberMe) localStorage.setItem("savedLoginId", loginId.trim());
        else localStorage.removeItem("savedLoginId");
      } catch {
        // localStorage blocked on this browser -- login still succeeds, just won't be remembered.
      }
      onLogin();
    } catch {
      setError("Email/Username ya password galat hai!");
    }
    setLoading(false);
  };

  const handleReset = async () => {
    if (!resetEmail.trim()) { setResetError("Email bharein!"); return; }
    setResetSending(true); setResetError(""); setResetMsg("");
    try {
      await sendPasswordResetEmail(auth, resetEmail.trim());
      setResetMsg("Reset link bhej diya! Email check karein (spam bhi dekho).");
      setResetEmail("");
    } catch (err) {
      if (err.code === "auth/user-not-found") setResetError("Yeh email registered nahi hai!");
      else setResetError("Kuch galat hua, dobara try karein!");
    }
    setResetSending(false);
  };

  const handleKey = (e) => { if (e.key === "Enter") handleLogin(); };

  return (
    <div style={S.container}>
      <div style={S.card} className="gbs-fade-in">
        {onBack && (
          <p style={{ textAlign: "left", fontSize: 13, color: "#9CA3AF", cursor: "pointer", marginBottom: 12, fontWeight: 600 }} onClick={onBack}>
            ← Wapas
          </p>
        )}
        <img src={gbsLogo} alt="Global Bahuudeshiya Sanstha" style={{ ...S.logoImage, cursor: "pointer" }} onClick={onBack} />
        <h1 style={S.title}>Global Bahuudeshiya Sanstha</h1>
        <p style={S.subtitle}>Sthapana 2013 · Seva aur Vikas</p>

        {!showForgot ? (
          <>
            <input
              style={S.input}
              placeholder="Email ya Username"
              value={loginId}
              onChange={e => setLoginId(e.target.value)}
              onKeyDown={handleKey}
            />
            <div style={S.passwordRow}>
              <input
                style={{ ...S.input, marginBottom: 0, flex: 1 }}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={handleKey}
              />
              <button onClick={() => setShowPassword(p => !p)} style={S.eyeBtn} type="button">
                <Icon name={showPassword ? "eye-off" : "eye"} size={18} color="#9CA3AF" />
              </button>
            </div>
            <div style={{ height: 14 }} />

            <div style={S.bottomRow}>
              <label style={S.rememberRow}>
                <input type="checkbox" checked={rememberMe}
                  onChange={e => setRememberMe(e.target.checked)}
                  style={{ accentColor: "#0D1B3E", cursor: "pointer" }} />
                <span style={S.rememberLabel}>Yaad rakho</span>
              </label>
              <span style={S.forgotLink} onClick={() => { setShowForgot(true); setError(""); }}>
                Password bhool gaye?
              </span>
            </div>

            {error && <p style={S.error}>{error}</p>}

            <button style={S.button} onClick={handleLogin} disabled={loading}>
              {loading ? "Loading..." : "Login Karein"}
            </button>

            <p style={S.footerText}>
              Member nahi hain?{" "}
              <span style={S.footerLink} onClick={onRegister}>Register karein</span>
            </p>
          </>
        ) : (
          <>
            <div style={{ textAlign: "left", marginBottom: 4 }}>
              <p style={S.resetTitle}>Password Reset</p>
              <p style={S.resetSubtitle}>Apna registered email likhein — reset link bhej denge.</p>
              <input
                style={S.input}
                placeholder="Registered Email"
                value={resetEmail}
                onChange={e => setResetEmail(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleReset()}
                autoFocus
              />
              {resetError && <p style={S.error}>{resetError}</p>}
              {resetMsg && <p style={S.successMsg}>{resetMsg}</p>}
              <button style={S.button} onClick={handleReset} disabled={resetSending}>
                {resetSending ? "Bhej rahe hain..." : "Reset Link Bhejo"}
              </button>
            </div>
            <p style={S.footerText} onClick={() => { setShowForgot(false); setResetMsg(""); setResetError(""); }}>
              <span style={S.footerLink}>← Wapas Login pe jaayein</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

function Icon({ name, size = 18, color = "#0D1B3E" }) {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "eye": return <svg {...common}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>;
    case "eye-off": return <svg {...common}><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19M14.12 14.12a3 3 0 1 1-4.24-4.24" /><path d="M1 1l22 22" /></svg>;
    default: return null;
  }
}

const S = {
  container: { minHeight: "100vh", background: "linear-gradient(135deg, #0D1B3E, #1A2F5A)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 },
  card: { background: "#fff", borderRadius: 24, padding: "40px 28px", width: "100%", maxWidth: 380, textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" },
  logoImage: { width: 88, height: 88, objectFit: "contain", margin: "0 auto 16px", display: "block" },
  title: { fontSize: 17, fontWeight: 700, color: "#0D1B3E", margin: "0 0 4px", lineHeight: 1.3 },
  subtitle: { fontSize: 12, color: "#9CA3AF", marginBottom: 28 },
  input: { width: "100%", padding: "13px 14px", borderRadius: 12, border: "1px solid #ECECEE", fontSize: 14, marginBottom: 12, boxSizing: "border-box", outline: "none", background: "#FAFAFA" },
  passwordRow: { display: "flex", alignItems: "center", position: "relative" },
  eyeBtn: { position: "absolute", right: 12, background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex" },
  bottomRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 },
  rememberRow: { display: "flex", alignItems: "center", gap: 6, cursor: "pointer" },
  rememberLabel: { fontSize: 12, color: "#6B7280" },
  forgotLink: { fontSize: 12, color: "#0D1B3E", fontWeight: 600, cursor: "pointer" },
  button: { width: "100%", padding: 14, background: "#0D1B3E", color: "#fff", border: "none", borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: "pointer" },
  error: { color: "#DC2626", fontSize: 12, marginBottom: 10, textAlign: "left" },
  successMsg: { color: "#16A34A", fontSize: 12, marginBottom: 10, textAlign: "left", fontWeight: 600 },
  resetTitle: { fontSize: 16, fontWeight: 700, color: "#0D1B3E", margin: "0 0 6px" },
  resetSubtitle: { fontSize: 12, color: "#9CA3AF", marginBottom: 16 },
  footerText: { textAlign: "center", fontSize: 13, color: "#9CA3AF", marginTop: 18, cursor: "pointer" },
  footerLink: { color: "#0D1B3E", fontWeight: 600, cursor: "pointer" },
};